export default __webpack_public_path__ + "static/media/mod04.11c6f022.svg";